export default "__VITE_ASSET__BIxEoF0Q__"